<template>
  <HXContentCard title="Proveedor SMTP">
    <b-row class="m-4">
      <b-col md="4">
        <label for="supplier-select" class="form-label">Proveedor en uso</label>
        <v-select id="supplier-select" v-model="selectedSupplier" :options="supplierList" label="supplierName"
          :reduce="supplier => supplier" placeholder="-- Seleccionar proveedor --" @input="updateSelectedSupplier">
        </v-select>
      </b-col>
    </b-row>
  </HXContentCard>
</template>

<script>
import Swal from "sweetalert2";

export default {
  data() {
    return {
      supplierList: [],
      selectedSupplier: null,
    };
  },

  async mounted() {
    await this.fetchSupplierList();
  },
  methods: {
    async fetchSupplierList() {
      try {
        const res = await this.$store.dispatch("hl_get", {
          path: "SupplierSMTP",
        });
        if (!res || res.length === 0) {
          this.showSweetAlert("Información", "No hay proveedores SMTP disponibles.", "info");
          return;
        }
        // console.log("res", res);
        this.supplierList = res;
        this.selectedSupplier = res.find((supplier) => supplier.using);

      } catch (error) {
        console.error("Error fetching supplier list:", error);
        this.supplierList = [];
      }
    },
    async updateSelectedSupplier(supplier) {
      try {
        const res = await this.$store.dispatch("hl_put", {
          path: `SupplierSMTP/${supplier.id}/use`,
        });

        if (!res) {
          this.showSweetAlert("Error", "No se pudo actualizar el proveedor SMTP.", "error");
          return;
        }

        this.showSweetAlert("Proveedor actualizado", "Se activó correctamente el proveedor SMTP.", "success");

        await this.fetchSupplierList();

      } catch (error) {
        console.error("Error actualizando proveedor:", error);
        this.showSweetAlert("Error", "No se pudo actualizar el proveedor SMTP.", "error");
      }
    }
    ,
    showSweetAlert(title, text, icon) {
      Swal.fire({
        title: title,
        text: text,
        icon: icon,
        showCancelButton: false,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "OK",
      });
    },
  },
};
</script>

<style scoped></style>
